import { createContext, useContext } from 'react';

//App Context
export const AppContext = createContext({
  customers: null,
  employers: [],
  dataFetched: false,
  setDataFetched: () => {},
  fetchEmployersAndClients: () => {},
});

//Use App Context
export function useAppContext() {
  return useContext(AppContext);
}
